import React from "react";

const NeccGroupInner = () => {
  return (
    <>
      {/* Start Services area  */}
      <div className='service-area pd-top-120 pd-bottom-45'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-11'>
              <div className='service-details-wrap'>
                <h2>NECC GROUP</h2>
                <p>
                Established in Year 1968, NECC Group is one of the top logistic companies in India. Our offices are located throughout the India. We offer a wide range of transport related services to meet every customer requirement.
                </p>
                <p>
                Our services include supply chain management, freight management, full truck load services and All India transport services. Our aim is to meet global standards to compete in dynamically expanding industries. We are one of the fastest growing logistic companies in the world. Our team is dedicated, experienced and care for your business needs.
                </p>
               
                  
                    <h4 className='subtitle'>Team NECC strives to attain Delivery and Distribution excellence:</h4>
                    <ul className='list-inner-wrap'>
                      <li> We align organizational resources and internal systems</li>
                      <li> We adopt appropriate technology and provide easier exchange of information</li>
                      <li> We offer customized services and products through specialized divisions</li>
                    </ul>
                
               
             
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider-area divider-default-area">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-sm-11 col-md-12">
            <div class="content">
              <p class="title">TEAM NECC IS COMMITED TO EXCEED CLIENT EXPECTATIONS</p>
            </div>
          </div>
        </div>
      </div>
    </div>
   
      {/* End Services area  */}
    </>
  );
};

export default NeccGroupInner;
